<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <Loading v-if="loading === true"/>
            <div class="content">
                <div class="card">
                    <div class="card-header">
                        <h4 class="mt-0">Reports</h4>
                    </div>
                    <div class="card-body">
                         <select v-if="isSuperAdmin !== true" class="form-control custom-dropdown mb-5" v-model="selectedMuseum" @change="getMuseumListings()">
                            <option disabled value="">Institutes</option>
                            <option v-for="museum in museums" :key="museum.id" :value="museum">{{museum.name}}</option>
                        </select>
                        <p><b>Select the report you would like to see:</b></p>
                        <div class="row mb-5">
                            <div class="col">
                                <button :class="showArtists === true ? 'btn btn-primary active-report' : 'btn btn-primary'" @click="viewArtists()">View Artists</button>
                            </div>
                            <div v-if="isSuperAdmin === true" class="col">
                                <button :class="showCurators === true ? 'btn btn-primary active-report' : 'btn btn-primary'" @click="viewCurators()">View Curators</button>
                            </div>
                            <div v-if="isSuperAdmin === true" class="col">
                                <button :class="showMuseums === true ? 'btn btn-primary active-report' : 'btn btn-primary'" @click="viewMuseums()">View Institutes</button>
                            </div>
                            <div class="col">
                                <button :class="showListings === true ? 'btn btn-primary active-report' : 'btn btn-primary'" @click="showArtworks()">View Artworks</button>
                            </div>
                        </div>

                        <!-- Artist Filters -->
                        <div v-if="showArtists === true" class="row mb-4">
                            <div class="col-12 ml-5">
                                <label class="form-check-label ml-4">Bulk Filters:</label>
                            </div>
                            <div class="col-12 ml-5">
                                <input type="checkbox" class="form-check-input" id="artistBirth" @click="applyFilter('dateOfBirth')">
                                <label class="form-check-label">Year of Birth not Set</label>
                            </div>
                            <div class="col-12 ml-5">
                                <input type="checkbox" class="form-check-input" id="artistDeath" @click="applyFilter('dateOfDeath')">
                                <label class="form-check-label">Year of Death not Set</label>
                            </div>
                            <div class="col-12 ml-5">
                                <input type="checkbox" class="form-check-input" id="artistProfilePic" @click="applyFilter('profilePic')">
                                <label class="form-check-label">Profile Picture not Set</label>
                            </div>
                            <div class="col-12 ml-5">
                              <input type="checkbox" class="form-check-input" id="artistApproved" @click="applyFilter('artistApproved')">
                              <label class="form-check-label">Not Approved</label>
                            </div>
                        </div>

                        <!-- Artist Table -->
                        <div v-if="showArtists === true" class="container-fluid">
                          <div class="row">
                            <div class="col">

                              <download-excel
                                  :data   = "artistData"
                                  :fields = "artistExportColumns"
                                  name    = "Artist-Report.csv"
                                  type    = "csv"
                                  class = "btn btn-sm btn-primary float-right"
                              >
                                Export CSV
                              </download-excel>

                              <download-excel
                                  :data   = "artistData"
                                  :fields = "artistExportColumns"
                                  name    = "Artist-Report.xls"
                                  class   = "btn btn-sm btn-primary float-right"
                              >
                                Export Excel
                              </download-excel>

                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <v-client-table ref="artistTable" :data="artistData" :columns="artistColumns" :options="artistOptions">
                              </v-client-table>
                            </div>
                          </div>
                        </div>


                        <!-- Curator Table -->
                      <div v-if="showCurators === true && isSuperAdmin === true" class="container-fluid">
                        <div class="row">
                          <div class="col">

                            <download-excel
                                :data   = "curatorData"
                                :fields = "curatorExportColumns"
                                name    = "Curator-Report.csv"
                                type    = "csv"
                                class = "btn btn-sm btn-primary float-right"
                            >
                              Export CSV
                            </download-excel>

                            <download-excel
                                :data   = "curatorData"
                                :fields = "curatorExportColumns"
                                name    = "Curator-Report.xls"
                                class   = "btn btn-sm btn-primary float-right"
                            >
                              Export Excel
                            </download-excel>

                          </div>
                        </div>
                        <div class="row">
                          <div class="col">

                            <v-client-table ref="curatorTable" :data="curatorData" :columns="curatorColumns" :options="curatorOptions">
                            </v-client-table>
                          </div>
                        </div>
                      </div>

                        <!-- Museum Table -->
                      <div v-if="showMuseums === true && isSuperAdmin === true" class="container-fluid">
                        <div class="row">
                          <div class="col">

                            <download-excel
                                :data   = "museumData"
                                :fields = "museumExportColumns"
                                name    = "Institute-Report.csv"
                                type    = "csv"
                                class = "btn btn-sm btn-primary float-right"
                            >
                              Export CSV
                            </download-excel>

                            <download-excel
                                :data   = "museumData"
                                :fields = "museumExportColumns"
                                name    = "Institute-Report.xls"
                                class   = "btn btn-sm btn-primary float-right"
                            >
                              Export Excel
                            </download-excel>

                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <v-client-table ref="museumTable" :data="museumData" :columns="museumColumns" :options="museumOptions">
                            </v-client-table>
                          </div>
                        </div>
                      </div>


                         <!-- Artworks Table -->
                      <div v-if="showListings === true" class="container-fluid">
                        <div class="row">
                          <div class="col">

                            <download-excel
                                :data   = "listingData"
                                :fields = "listingExportColumns"
                                name    = "Artwork-Report.csv"
                                type    = "csv"
                                class = "btn btn-sm btn-primary float-right"
                            >
                              Export CSV
                            </download-excel>

                            <download-excel
                                :data   = "listingData"
                                :fields = "listingExportColumns"
                                name    = "Artwork-Report.xls"
                                class   = "btn btn-sm btn-primary float-right"
                            >
                              Export Excel
                            </download-excel>

                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <v-client-table ref="listingTable" :data="listingData" :columns="listingColumns" :options="listingOptions">
                            </v-client-table>
                          </div>
                        </div>
                      </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
    import isSuperAdmin from '../services/jwt/isSuperAdmin';
    import Artists from '../controllers/artist.controller';
    import Listings from '../controllers/listing.controller';
    import Admins from '../controllers/admin.controller';
    import Museums from '../controllers/museum.controller';
    import getUID from '../services/jwt/getUID';

    export default {
        name: 'Reports',
        data: function() {
            return {
                loading: false,
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                museums:[],
                selectedMuseum: '',

                // ARTIST REPORT DATA
                showArtists: false,
                artistColumns: ['name', 'birthday', 'deathDay', 'listingTotal', 'image', 'approved', 'createdBy', 'createdAt'],
                artistData: [],
                allArtists: [],
                artistExportColumns: {
                  "Name": "name",
                  "Year of Birth": "birthday",
                  "Year of Death": "deathDay",
                  "Total Artwork Count": "listingTotal",
                  "Profile Picture": "image",
                  "Approved": "approved",
                  "Created By": "createdBy",
                  "Created At": "createdAt",
                },
                artistOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    filterable: true,
                    headings: {
                        name: 'Name',
                        birthday: 'Year of Birth',
                        deathDay: 'Year of Death',
                        listingTotal: 'Total Artwork Count',
                        image: 'Profile Picture',
                        approved: 'Approved',
                        createdBy: 'Created By (Handle)',
                        createdAt: 'Created At'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },

                // CURATOR REPORT DATA
                showCurators: false,
                curatorColumns: ['name', 'displayName', 'jobTitle', 'email', 'museum', 'subscription', 'createdAt'],
                curatorData: [],
                curatorExportColumns: {
                  "Name": "name",
                  "Display Name": "displayName",
                  "Job Title": "jobTitle",
                  "Email": "email",
                  "Subscription Plan": "subscription",
                  "Institute": "museum",
                  "Created At": "createdAt",
                },
                curatorOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    filterable: true,
                    headings: {
                        name: 'Name',
                        displayName: 'Display Name',
                        jobTitle: 'Job Title',
                        email: 'Email',
                        subscription: 'Subscription Plan',
                        museum: 'Institute',
                        createdAt: 'Created At'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },

                // INSTITUTE REPORT DATA
                showMuseums: false,
                museumColumns: ['name', 'address', 'createdBy', 'createdAt'],
                museumData: [],
                museumExportColumns: {
                    "Name": "name",
                    "Address": "address",
                    "Created By (Handle)": "createdBy",
                    "Created At": "createdAt"
                },
                museumOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    filterable: true,
                    headings: {
                        name: 'Name',
                        address: 'Address',
                        createdBy: 'Created By (Handle)',
                        createdAt: 'Created At'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },

                // ARTWORK REPORT DATA
                showListings: false,
                listingColumns: ['name', 'artist', 'era', 'medium', 'museum', 'createdBy', 'createdAt'],
                listingData: [],
                listingExportColumns: {
                  "Name": "name",
                  "Artist": "artist",
                  "Era": "era",
                  "Medium": "medium",
                  "Institute": "museum",
                  "Created By (Handle)": "createdBy",
                  "Created At": "createdAt"
                },
                listingOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    filterable: true,
                    headings: {
                        name: 'Name',
                        artist: 'Artist',
                        era: 'Era',
                        medium: 'Medium',
                        museum: 'Institute',
                        createdBy: 'Created By',
                        createdAt: 'Created At'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },

                filterDateBirth: false,
                filterDateDeath: false,
                filterProfilePic: false,
                filterApproved: false
            }
        },
        beforeMount: async function() {
            if (this.isSuperAdmin === false) {
                let uid = await getUID(localStorage.getItem('superAdmin'));
                this.museums = await Museums.getCuratorMuseums(uid);
                this.selectedMuseum = this.museums[0];
            }
        },
        methods: {
            async viewArtists() {
                this.loading = true;
                this.artistData = [];
                this.clearAllTableFilters();

                let artists = await Artists.getAll();

                for (let artist of artists) {

                    let birthDate = artist.date_of_birth === "0000-00-00" || artist.date_of_birth === null ? "N/A" : artist.date_of_birth.toString();
                    let deathDate = artist.date_of_death === "0000-00-00" || artist.date_of_death === null ? "N/A" : artist.date_of_death.toString();
                    let createdBy = !artist.createdBy ? "N/A" : "@" + artist.createdBy.display_name;
                    let artworkCount = artist.listings === null ? 0 : artist.listings.length;
                    let createdAt = this.formatDate(artist.created_at);

                    let data = {
                        id: artist.artist_id,
                        name: artist.name,
                        birthday: birthDate,
                        deathDay: deathDate,
                        image: !artist.image ? "NO" : "YES",
                        listingTotal: artworkCount,
                        createdBy: createdBy,
                        createdAt: createdAt,
                        approved: artist.approved === 1 ? "YES" : "NO"
                    };

                    if (this.isSuperAdmin) {
                        // Super admins can see everything, including artists without listings or that are not tied to
                        // an institute.
                        this.artistData.push(data);
                    } else {
                        // We need to filter out the artist so it only shows what is in the curators institute.
                        for (let listing of artist.listings) {
                            if (listing.museum != null && this.selectedMuseum.id === listing.museum.id) {
                                if (this.containsArtist(artist, this.artistData) === false) {
                                    this.artistData.push(data);
                                }
                            }
                        }
                    }

                }

                this.allArtists = this.artistData;
                this.loading = false;
                this.show("artists");
            },

            async viewCurators() {
                if (this.isSuperAdmin === true) {
                    this.loading = true;
                    this.curatorData = [];
                    this.clearAllTableFilters();

                    let curators = await Admins.getCurators();

                    for (let curator of curators) {
                        let createdAt = this.formatDate(curator.created_at);

                        this.curatorData.push({
                            name: curator.name,
                            displayName: curator.display_name,
                            jobTitle: curator.job_title,
                            email: !curator.email ? "N/A" : curator.email,
                            museum: !curator.curator_museums[0] ? "N/A" : curator.curator_museums[0].name,
                            subscription: !curator.subscription ? "N/A" : curator.subscription.subscription_status,
                            createdAt: createdAt
                        });
                    }

                    this.show("curators");
                    this.loading = false;
                }
            },

            async viewMuseums() {
                this.loading = true;
                this.museumData = [];
                this.clearAllTableFilters();

                let museums = await Museums.getAll();

                for (let museum of museums) {
                    let createdAt = this.formatDate(museum.created_at);

                    this.museumData.push({
                        name: museum.name,
                        address: museum.address.address_1 + ' ' + museum.address.city + ' ' + museum.address.state + ' ' + museum.address.postal_code + ' ' + museum.address.country,
                        createdBy: !museum.createdBy ? "N/A" : "@" + museum.createdBy.display_name,
                        createdAt: createdAt
                    });
                }

                this.show("museums");
                this.loading = false;
            },

            async showArtworks() {
                this.loading = true;
                this.listingData = [];
                this.clearAllTableFilters();

                let listings = this.isSuperAdmin === true ? await Listings.getAll() : await Listings.getByMuseumID(this.selectedMuseum.id);

                for (let listing of listings) {
                    let createdAt = this.formatDate(listing.created_at);

                    this.listingData.push({
                        name: !listing.museum ? "Public Art" : listing.name,                
                        artist: !listing.artist ? "N/A" : listing.artist.name,
                        era: !listing.era ? "N/A" : listing.era.name,
                        medium: !listing.medium ? "N/A" : listing.medium.name,
                        museum: !listing.museum ? "N/A" : listing.museum.name,
                        createdBy: !listing.createdBy ? "N/A" : "@" + listing.createdBy.display_name,
                        createdAt:  createdAt
                    });
                }
                
                this.show("listings");
                this.loading = false;
            },

            show(table) {
                switch (table) {
                    case "artists":
                        this.showListings = false;
                        this.showMuseums = false;
                        this.showCurators = false;
                        this.showArtists = true;
                        break;

                    case "curators":
                        this.showListings = false;
                        this.showMuseums = false;
                        this.showArtists = false;
                        this.showCurators = true;
                        break;

                    case "museums":
                        this.showListings = false;
                        this.showArtists = false;
                        this.showCurators = false;
                        this.showMuseums = true;
                        break;

                    case "listings":
                        this.showArtists = false;
                        this.showCurators = false;
                        this.showMuseums = false;
                        this.showListings = true;
                        break;
                    
                    default:
                        break;
                }
            },

            formatDate(date) {
                let createdAt = new Date(date);
                let day = createdAt.getDate() < 10 ? "0" + createdAt.getDate() : createdAt.getDate();
                let month = (createdAt.getMonth() + 1) < 10 ? "0" + (createdAt.getMonth() + 1) : (createdAt.getMonth() + 1);
                return month + "/" + day + "/" + createdAt.getFullYear();
            },

            applyFilter(filter) {
                this.loading = true;

                switch (filter) {
                    case "dateOfBirth":
                        this.filterDateBirth = !this.filterDateBirth;
                        this.filterArtists();
                        break;
                    
                    case "dateOfDeath":
                        this.filterDateDeath = !this.filterDateDeath;
                        this.filterArtists();
                        break;
                    
                    case "profilePic":
                        this.filterProfilePic = !this.filterProfilePic;
                        this.filterArtists();
                        break;

                    case "artistApproved":
                        this.filterApproved = !this.filterApproved;
                        this.filterArtists();
                      break;

                    default:
                        break;
                }

                this.loading = false;
            },

            containsArtist(artist, artistList) {
                for (let currentArtist of artistList) {
                    if (artist.id == currentArtist.id) {
                        return true;
                    }
                }

                return false;
            },

            filterArtists() {

                if (
                    this.filterDateBirth === false &&
                    this.filterDateDeath === false &&
                    this.filterProfilePic === false &&
                    this.filterApproved === false) {

                    this.artistData = this.allArtists;

                } else {

                    let filteredArtists = this.allArtists;
                    let remainingArtists = [];

                    // Remove any artists from the list that has a date of birth.
                    if (this.filterDateBirth === true) {
                        filteredArtists.forEach((artist) => {
                            if (artist.birthday === "N/A") {
                                remainingArtists.push(artist);
                            }
                        });
                        // Update the filtered array
                        filteredArtists = remainingArtists;
                    }

                    // Remove any artist left in the list that has a date of death
                    if (this.filterDateDeath === true) {
                        remainingArtists = [];
                        filteredArtists.forEach((artist) => {
                            if (artist.deathDay === "N/A") {
                                remainingArtists.push(artist);
                            }
                        });
                        // Update the filtered array
                        filteredArtists = remainingArtists;
                    }

                    // Remove any artist left in the list that has a profile pic.
                    if (this.filterProfilePic === true) {
                        remainingArtists = [];
                        filteredArtists.forEach((artist) => {
                            if (artist.image === "NO") {
                                remainingArtists.push(artist)
                            }
                        });
                        // Update the filtered array
                        filteredArtists = remainingArtists;
                    }

                    // Finally remove any artist left in the list that has been approved.
                    if (this.filterApproved === true) {
                        remainingArtists = [];
                        filteredArtists.forEach((artist) => {
                            if (artist.approved === "NO") {
                                remainingArtists.push(artist);
                            }
                        });
                        // Update the filtered array
                        filteredArtists = remainingArtists;
                    }

                    this.artistData = filteredArtists;

                }

            },

            clearAllTableFilters() {
                if (this.$refs.artistTable) {
                    this.$refs.artistTable.setFilter('');
                }

                if (this.$refs.museumTable) {
                    this.$refs.museumTable.setFilter('');
                }

                if (this.$refs.curatorTable) {
                    this.$refs.curatorTable.setFilter('');
                }

                if (this.$refs.listingTable) {
                    this.$refs.listingTable.setFilter('');
                }
            }
        }
    }
</script>